import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IPendingInvitedEmployeesQuickSearchResponse } from '../../../shared/models/shared.model';

export const administratorsPendingBusinessManagementUserQuickSearchFeatureKey = 'administratorsPendingBusinessManagementUserQuickSearch';

export interface AdministratorsPendingBusinessManagementUserQuickSearchState {
  loadAdministratorsPendingBusinessManagementUserQuickSearchResponse: IPendingInvitedEmployeesQuickSearchResponse;
  loadAdministratorsPendingBusinessManagementUserQuickSearchFailure: Error | any;
  isFirstTimeLoad: boolean;
}

export const initialState: AdministratorsPendingBusinessManagementUserQuickSearchState = {
  loadAdministratorsPendingBusinessManagementUserQuickSearchResponse: undefined,
  loadAdministratorsPendingBusinessManagementUserQuickSearchFailure: undefined,
  isFirstTimeLoad: true
};

export const reducer = createReducer(
  initialState,
  on(actions.loadAdministratorsPendingInvitedBusinessManagementUserQuickSearchsSuccess, (state, action) => ({
    ...state,
    loadAdministratorsPendingBusinessManagementUserQuickSearchResponse: action.response
  })),
  on(actions.loadAdministratorsPendingInvitedBusinessManagementUserQuickSearchsFailure, (state, action) => ({
    ...state,
    loadAdministratorsPendingBusinessManagementUserQuickSearchFailure: action.error
  })),
  on(actions.clearAdministratorsPendingInvitedBusinessManagementUserQuickSearchs, (state, action) => ({
    ...state,
    loadAdministratorsPendingBusinessManagementUserQuickSearchResponse: undefined
  })),
  on(actions.isAdministratorsPendingInvitedFirstTimeLoad, (state, action) => ({
    ...state,
    isFirstTimeLoad: action.firstTimeLoad
  }))
);

export const getAdministratorsPendingBusinessManagementUserQuickSearchResponse = (
  state: AdministratorsPendingBusinessManagementUserQuickSearchState
) => state.loadAdministratorsPendingBusinessManagementUserQuickSearchResponse;

export const getAdministratorsIsFirstTimeLoad = (state: AdministratorsPendingBusinessManagementUserQuickSearchState) =>
  state.isFirstTimeLoad;
